<template>
    <div>
        <div class="container-fluid mb-4">
            <div class="button-navigation hide-scrollbar">
                <button :disabled="index == 3 || index == 4 || index == 5" class="btn" :class="[navMove === index ? 'active-navigation' : '']" @click="navMove = index; scrollToSection();"  v-for="(item, index) in navButtons" :key="index">
                    {{ item.name }}
                </button>
                
            </div>


            <div class="white-bg mb-3 tenant-button-section" v-if="navMove == 1">
                <div class="">
                    <h4 class="headings">Tenant Information</h4>
                    <!-- d-none d-sm-block Hide on small devices -->
                    <h6 class="subheadings">Here are all the tenant informations on your property, click to add new tenant or request rent from tenant </h6>
                </div>
                <div>
                    <button class="btn sheltaBtn" disabled>Add new tenant</button>
                </div>
            </div>

            <div class="white-bg">
                <div class="" v-if="navMove == 0">
                    <div class="">
                        <h4 class="headings">My Properties</h4>
                        <h6 class="subheadings">Here are all your properties and status </h6>
                    </div>
                </div>

                

                <div class="buttonNavigation-holder" v-if="navMove == 0">
                    <!-- <div class="buttonNavigation hide-scrollbar">
                        <button class="btn plainButton" :class="[btnOptions == 'all' ? 'activePlain' : '']" @click="btnOptions = 'all'">All</button>
                        <button class="btn plainButton" :class="[btnOptions == 'occupied' ? 'activePlain' : '']" @click="btnOptions = 'occupied'">Occupied</button>
                        <button class="btn plainButton" :class="[btnOptions == 'vacant' ? 'activePlain' : '']" @click="btnOptions = 'vacant'">Vacant</button>
                        <button class="btn plainButton" :class="[btnOptions == 'maintenance' ? 'activePlain' : '']" @click="btnOptions = 'maintenance'">Under maintenance</button>
                    </div> -->
                    <div sty>
                        <button class="btn navyblueBtn gra" @click="navigateTo('guarentee-rent-home')">
                            Guarante Rent Request
                        </button>
                    </div>
                    
                    <div>
                        <button class="btn navyblueBtn" @click="navigateTo('/addproperty')">
                            Add Property
                        </button>
                    </div>
                </div>

                <div class="buttonNavigation-holder2" v-if="navMove == 1">
                    <div class="buttonNavigation hide-scrollbar">
                        <button class="btn plainButton" :class="[btnOptions == 'all' ? 'activePlain' : '']" @click="btnOptions = 'all'">All</button>
                        <button class="btn plainButton" :class="[btnOptions == 'occupied' ? 'activePlain' : '']" @click="btnOptions = 'occupied'">Rent due date</button>
                        <button class="btn plainButton" :class="[btnOptions == 'vacant' ? 'activePlain' : '']" @click="btnOptions = 'vacant'">Vacant</button>
                        <button class="btn plainButton" :class="[btnOptions == 'maintenance' ? 'activePlain' : '']" @click="btnOptions = 'maintenance'">Under maintenance</button>
                    </div>

                    <div>
                        <button class="btn navyblueBtn" disabled>
                            Request Rent
                        </button>
                    </div>
                    
                </div>
                <!-- <div class="empty__state" v-if="properties.length === 0 && !hideDiv">
                    <div class="empty__div">
                        <img src="../assets/images/empty-state.svg" alt="" />
                        <p>No property to view at the moment</p>
                    </div>
                </div>       -->
                <div v-if="hideDiv">
                    <PageLoader></PageLoader>
                </div>

                <div class="table-holder" style="padding: 0;" v-if="navMove == 0 && !hideDiv" ref="targetSection">
                    <div class="mb-3">
                        <input type="text" class="form-control" v-model="search" placeholder="Search with BATCH number">
                    </div>
                    <div class="table-responsive tableList">
                        <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                            <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Batch No.</th>
                                    <th scope="col">Address</th>
                                    <th scope="col">Units</th>
                                    <th scope="col">Total Rental Value</th>
                                    <th scope="col">Plan Type</th>
                                    <!-- <th scope="col">Status</th> -->
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- v-for="(item, index) in landlords"
                                    :key="index" -->
                                <tr v-for="(item, index) in filteredProperties" :key="index">
                                    <td>{{ item.batch }}</td>
                                    <td  class="text-wrap" style="max-width: 399px; min-width: 200px;">{{ item.address }}</td>
                                    <td>{{ item.units }}</td>
                                    <td>{{ Number(item.rental_value).toLocaleString() }}</td>
                                    <td>{{item.plan_type}}</td>
                                    <!-- <td> <span class="credit">{{ item.performance }} occupied</span></td> -->
                                    <td>
                                        <span @click="navigateTo(`/dashboard/landlord-prop-details/${item.batch}`)">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.9375 6.86422C14.205 4.14172 11.67 2.57422 9 2.57422C7.665 2.57422 6.3675 2.96422 5.1825 3.69172C3.9975 4.42672 2.9325 5.49922 2.0625 6.86422C1.3125 8.04172 1.3125 9.95422 2.0625 11.1317C3.795 13.8617 6.33 15.4217 9 15.4217C10.335 15.4217 11.6325 15.0317 12.8175 14.3042C14.0025 13.5692 15.0675 12.4967 15.9375 11.1317C16.6875 9.96172 16.6875 8.04172 15.9375 6.86422ZM9 12.0317C7.32 12.0317 5.97 10.6742 5.97 9.00172C5.97 7.32922 7.32 5.97172 9 5.97172C10.68 5.97172 12.03 7.32922 12.03 9.00172C12.03 10.6742 10.68 12.0317 9 12.0317Z" fill="#001C82"/>
                                                <path d="M9.00078 6.85547C7.82328 6.85547 6.86328 7.81547 6.86328 9.00047C6.86328 10.178 7.82328 11.138 9.00078 11.138C10.1783 11.138 11.1458 10.178 11.1458 9.00047C11.1458 7.82297 10.1783 6.85547 9.00078 6.85547Z" fill="#4A4A4A"/>
                                            </svg>
                                        </span>
                                        <span @click="moveToEditProp(item)" class="ml-3">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M6.53025 14.7819L13.5 7.81218L10.1895 4.50168L3.21975 11.4714C3.1238 11.5675 3.05564 11.6878 3.0225 11.8194L2.25 15.7517L6.1815 14.9792C6.3135 14.9462 6.43425 14.8779 6.53025 14.7819ZM15.75 5.56218C16.0312 5.28089 16.1892 4.89943 16.1892 4.50168C16.1892 4.10393 16.0312 3.72247 15.75 3.44118L14.5605 2.25168C14.2792 1.97047 13.8977 1.8125 13.5 1.8125C13.1023 1.8125 12.7208 1.97047 12.4395 2.25168L11.25 3.44118L14.5605 6.75168L15.75 5.56218Z" fill="#333333"/>
                                            </svg>

                                        </span>
                                    </td>
                                    <!-- <td></td> -->
                                    <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                </tr>   

                                <!-- <tr>
                                    <td>RR1026345434</td>
                                    <td>32, Lagos street, Abuja</td>
                                    <td>10</td>
                                    <td>32,000.00</td>
                                    <td>Starter</td>
                                    <td> <span class="credit">10 occupied</span></td>
                                    <td>
                                        <span @click="navigateTo('/dashboard/landlord-prop-details')">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.9375 6.86422C14.205 4.14172 11.67 2.57422 9 2.57422C7.665 2.57422 6.3675 2.96422 5.1825 3.69172C3.9975 4.42672 2.9325 5.49922 2.0625 6.86422C1.3125 8.04172 1.3125 9.95422 2.0625 11.1317C3.795 13.8617 6.33 15.4217 9 15.4217C10.335 15.4217 11.6325 15.0317 12.8175 14.3042C14.0025 13.5692 15.0675 12.4967 15.9375 11.1317C16.6875 9.96172 16.6875 8.04172 15.9375 6.86422ZM9 12.0317C7.32 12.0317 5.97 10.6742 5.97 9.00172C5.97 7.32922 7.32 5.97172 9 5.97172C10.68 5.97172 12.03 7.32922 12.03 9.00172C12.03 10.6742 10.68 12.0317 9 12.0317Z" fill="#001C82"/>
                                                <path d="M9.00078 6.85547C7.82328 6.85547 6.86328 7.81547 6.86328 9.00047C6.86328 10.178 7.82328 11.138 9.00078 11.138C10.1783 11.138 11.1458 10.178 11.1458 9.00047C11.1458 7.82297 10.1783 6.85547 9.00078 6.85547Z" fill="#4A4A4A"/>
                                            </svg>
                                        </span>
                                        <span class="ml-3">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M6.53025 14.7819L13.5 7.81218L10.1895 4.50168L3.21975 11.4714C3.1238 11.5675 3.05564 11.6878 3.0225 11.8194L2.25 15.7517L6.1815 14.9792C6.3135 14.9462 6.43425 14.8779 6.53025 14.7819ZM15.75 5.56218C16.0312 5.28089 16.1892 4.89943 16.1892 4.50168C16.1892 4.10393 16.0312 3.72247 15.75 3.44118L14.5605 2.25168C14.2792 1.97047 13.8977 1.8125 13.5 1.8125C13.1023 1.8125 12.7208 1.97047 12.4395 2.25168L11.25 3.44118L14.5605 6.75168L15.75 5.56218Z" fill="#333333"/>
                                            </svg>

                                        </span>
                                    </td>
                                </tr> 
                                <tr>
                                    <td>RR1026345434</td>
                                    <td>32, Lagos street, Abuja</td>
                                    <td>10</td>
                                    <td>32,000.00</td>
                                    <td>Starter</td>
                                    <td> <span class="credit">10 occupied</span></td>
                                    <td>
                                        <span @click="navigateTo('/dashboard/landlord-prop-details')">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.9375 6.86422C14.205 4.14172 11.67 2.57422 9 2.57422C7.665 2.57422 6.3675 2.96422 5.1825 3.69172C3.9975 4.42672 2.9325 5.49922 2.0625 6.86422C1.3125 8.04172 1.3125 9.95422 2.0625 11.1317C3.795 13.8617 6.33 15.4217 9 15.4217C10.335 15.4217 11.6325 15.0317 12.8175 14.3042C14.0025 13.5692 15.0675 12.4967 15.9375 11.1317C16.6875 9.96172 16.6875 8.04172 15.9375 6.86422ZM9 12.0317C7.32 12.0317 5.97 10.6742 5.97 9.00172C5.97 7.32922 7.32 5.97172 9 5.97172C10.68 5.97172 12.03 7.32922 12.03 9.00172C12.03 10.6742 10.68 12.0317 9 12.0317Z" fill="#001C82"/>
                                                <path d="M9.00078 6.85547C7.82328 6.85547 6.86328 7.81547 6.86328 9.00047C6.86328 10.178 7.82328 11.138 9.00078 11.138C10.1783 11.138 11.1458 10.178 11.1458 9.00047C11.1458 7.82297 10.1783 6.85547 9.00078 6.85547Z" fill="#4A4A4A"/>
                                            </svg>
                                        </span>
                                        <span class="ml-3">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M6.53025 14.7819L13.5 7.81218L10.1895 4.50168L3.21975 11.4714C3.1238 11.5675 3.05564 11.6878 3.0225 11.8194L2.25 15.7517L6.1815 14.9792C6.3135 14.9462 6.43425 14.8779 6.53025 14.7819ZM15.75 5.56218C16.0312 5.28089 16.1892 4.89943 16.1892 4.50168C16.1892 4.10393 16.0312 3.72247 15.75 3.44118L14.5605 2.25168C14.2792 1.97047 13.8977 1.8125 13.5 1.8125C13.1023 1.8125 12.7208 1.97047 12.4395 2.25168L11.25 3.44118L14.5605 6.75168L15.75 5.56218Z" fill="#333333"/>
                                            </svg>

                                        </span>
                                    </td>
                                </tr>  -->
                        
                            </tbody>
                        </table>
                        <div v-if="filteredProperties.length == 0" class="empty-state mt-5 mb-5">
                            <img src="../assets/icons/emptycan-state.svg" alt="empty">
                            <h5>No available data</h5>
                        </div>
                        <!-- <div v-if="properties.length == 0 && !hideDiv">
                            <EmptyState :emptyData="emptyDataObject2" />
                        </div> -->
                    </div>

                </div>

                <div class="table-holder" style="padding: 0;" v-if="navMove == 1 && !hideDiv" ref="targetSection">
                    <div class="mb-3 col-md-4 pl-0">
                        <input type="text" class="form-control" v-model="search2" placeholder="Search with name etc.">
                    </div>
                    <div class="table-responsive tableList">
                        <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                            <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Type</th>
                                    <th scope="col">Tenant name</th>
                                    <th scope="col">Phone number</th>
                                    <th scope="col">Address</th>
                                    
                                    <th scope="col">Property name</th>
                                    <th scope="col">Property type</th>
                                    <th scope="col">Rent due date</th>
                                    <th scope="col">Rent status</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- v-for="(item, index) in landlords"
                                    :key="index" -->
                                <tr  v-for="(item, index) in filteredTenants"
                                    :key="index">
                                    <td><span class="harmonized" :class="[item.type == 'R' ? 'reconciled' : '', item.type == 'H' ? 'harmonized' : '', item.type == 'G' ? 'guarantee' : '']">{{ item.type }}</span></td>
                                    <td>{{item.firstname}} {{ item.lastname }}</td>
                                    <td>{{ item.phone }}</td>
                                    <td class="text-wrap" style="max-width: 399px; min-width: 200px;">{{ item.address }}</td>
                                   
                                    <td>--</td>
                                    <td style="text-transform: capitalize;">{{item.property_type }}</td>
                                    <td>{{ item.rent_due_date | moment }}</td>
                                    <td> <span class="credit" :class="[item.status == 'paid' ? 'credit' : 'unpaid']">{{item.status}}</span></td>
                                    <td style="color: #0033EA">
                                        <span @click="navigateTo(`/dashboard/landlord-tenant-details/${item.tenant_id}`)">View</span>
                                    </td>
                                    <!-- <td></td> -->
                                    <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                </tr>   

                            
                        
                            </tbody>
                        </table>
                        <div v-if="filteredTenants.length == 0" class="empty-state mt-5 mb-5">
                            <img src="../assets/icons/emptycan-state.svg" alt="empty">
                            <h5>No available data</h5>
                        </div>
                        <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                            <EmptyState :emptyData="emptyDataObject2" />
                        </div> -->
                    </div>

                </div>

                <div class="table-holder" style="padding: 0;" v-if="navMove == 2 && !hideDiv" ref="targetSection">
                    <div class="mb-3">
                        <input type="text" class="form-control" placeholder="Search with ID etc.">
                    </div>
                    <div class="table-responsive tableList">
                        <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                            <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Personnel type</th>
                                    <th scope="col">Property name</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Company</th>
                                    <th scope="col">Phone number</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- v-for="(item, index) in landlords"
                                    :key="index" -->
                                <tr>
                                    <td>Lawyer</td>
                                    <td>Agog Estate</td>
                                    <td>Alex Mark John</td>
                                    <td>0ne Bedroom flat</td>
                                    <td>BBD Law firm</td>
                                    <td style="color: #0033EA">View</td>
                                    <!-- <td></td> -->
                                    <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                </tr>   

                                <tr>
                                    <td>Lawyer</td>
                                    <td>Agog Estate</td>
                                    <td>Alex Mark John</td>
                                    <td>0ne Bedroom flat</td>
                                    <td>BBD Law firm</td>
                                    <td style="color: #0033EA">View</td>
                                    <!-- <td></td> -->
                                    <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                </tr>  
                                <tr>
                                    <td>Lawyer</td>
                                    <td>Agog Estate</td>
                                    <td>Alex Mark John</td>
                                    <td>0ne Bedroom flat</td>
                                    <td>BBD Law firm</td>
                                    <td style="color: #0033EA">View</td>
                                    <!-- <td></td> -->
                                    <!-- <span :class="[data.type == 'credit' ? 'credit' : 'debit']" class=""></span> -->
                                </tr>  
                        
                            </tbody>
                        </table>
                        <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                            <EmptyState :emptyData="emptyDataObject2" />
                        </div> -->
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
import PageLoader from "./PageLoader.vue";
import '@/assets/styles/custom.scss';
// import PageLoader from "./PageLoader.vue";
import { Service } from "../store/service";
const Api = new Service();
import moment from "moment";

export default {
    name: "LandlordProperties2",
    components: {
        PageLoader
    },
    data() {
        return {
            loading: false,
            hideDiv: false,
            navButtons: [
                { name: 'My properties' },
                { name: 'Tenants' },
                // { name: 'Personnels' },
                // { name: 'Inspections' },
                // { name: 'Maintenance' },
                // { name: 'Documents' },
            ],
            navMove: 0,
            btnOptions: "all",
            id: "",
            properties: [],
            tenants: [],
            search: "",
            search2: "",
        }
    },
    computed: {
        filteredProperties() {
            return this.properties.filter((item) =>
                item.batch.toLowerCase().includes(this.search.toLowerCase())
            );
        },
        filteredTenants() {
            return this.tenants.filter((item) =>
                item.firstname.toLowerCase().includes(this.search2.toLowerCase()) ||
                item.lastname.toLowerCase().includes(this.search2.toLowerCase())
            );
        },
    },
    mounted() {
        this.id = JSON.parse(localStorage.getItem("shelta-user")).id;
        // this.getUserProfile();
        this.fetchLandlordProperties();
        this.fetchLandlordTenants();
    },
    methods: {
        scrollToSection() {
            this.$refs.targetSection.scrollIntoView({ behavior: 'smooth' });
        },
        navigateTo(route) {
            return this.$router.push({
                path: route
            });
        },

        moveToEditProp(propData) {
            // Api.pushPropertyDetails(propData);
            // this.$router.push({
            //     path: `/editproperty`
            // });
        },

        async fetchLandlordTenants() {
        this.hideDiv = true;
        // this.loader = true;
        try {
            await Api.getRequest(`new-dashboard-landlord-tenants`)
            .then(res => {
                // if (res.data.error) {
                //   this.hideDiv = false;
                // }
                // console.log("Tenants", res);
                if (res.data.success) {
                this.tenants = res.data.tenants;
                }
                this.hideDiv = false;
            })
            .catch(err => {
                // console.log(err);
                this.hideDiv = false;
                // this.loader = false;
            });
        } finally {
            // console.log("Closed connection");
        }
        },
        async fetchLandlordProperties() {
        this.hideDiv = true;
        // this.loader = true;
        try {
            // fetchpropertiesbylandlordid/${this.id}
            await Api.getRequest(`new-dashboard-landlord-properties`)
            .then(res => {
                // if (res.data.error) {
                //   this.hideDiv = false;
                // }
                console.log("Properties", res);
                if (res.data.success) {
                this.properties = res.data.properties;
                }
                this.hideDiv = false;
            })
            .catch(err => {
                // console.log(err);
                this.hideDiv = false;
                // this.loader = false;
            });
        } finally {
            // console.log("Closed connection");
        }
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        }
    }
}
</script>


<style lang="scss" scoped>


.tenant-button-section {
    display: flex;
    justify-content: space-between;
}
.buttonNavigation-holder {
    margin-top: 20px;
    // border: 1px solid #E5E7EB;
    padding: 4px 16px;
    border-radius: 8px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    
}
.buttonNavigation-holder2 {
    margin-top: 20px;
    padding: 4px 0px;
    text-align: left;
    display: flex;
    justify-content: space-between;
}
.buttonNavigation {
    // display: flex;
    overflow: scroll;
    white-space: nowrap;
}

.activePlain {
    background:#00155F !important;
    color: #ffffff !important;
    font-family: Lato;
    font-weight: 600 !important;
}


.credit {
    background: #84EBB4;
    border-radius: 50px;
    color: #374151;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}
.debit {
    background: #DFA052;
    border-radius: 50px;
    color: #333333;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}
.unpaid {
    background: #D2D2D2;
    border-radius: 50px;
    color: #333333;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}

.harmonized {
    background: #0033EA;
    color: #ffffff;
    font-family: Lato;
    font-weight: 700;
    font-size: 12px;
    // line-height: 16px;
    text-align: center;
    width: 29px;
    height: 20px;
    border-radius: 30px;
    padding: 2px 10px;

}
.guarantee {
    background: #1FC16B;
    color: #333333;
    font-family: Lato;
    font-weight: 700;
    font-size: 12px;
    // line-height: 16px;
    text-align: center;
    width: 29px;
    height: 20px;
    border-radius: 30px;
    padding: 2px 10px;
}

.reconciled {
    background: #DFB400;
    color: #374151;
    font-family: Lato;
    font-weight: 700;
    font-size: 12px;
    // line-height: 16px;
    text-align: center;
    width: 29px;
    height: 20px;
    border-radius: 30px;
    padding: 2px 10px;
}

// tbody {
//     td {
//         white-space: normal !important;
//     }
// }

.gra {
    background: #0329ab !important;
}
@media screen and (max-width: 599px) {
    .tenant-button-section {
        display: block;
        .sheltaBtn {
            width: 100%;
        }
    }
    .buttonNavigation-holder {
        display: block;
        padding-top: 15px;
        padding-bottom: 15px;
        .navyblueBtn {
            width: 100%;
            margin-bottom: 10px;
        }
    }
    .buttonNavigation-holder2 {
        display: block;
        padding-top: 15px;
        padding-bottom: 15px;
        .navyblueBtn {
            width: 100%;
            margin-bottom: 10px;
        }
    }
    .buttonNavigation {
        margin-bottom: 30px;
    }
 }

</style>